import React from 'react';
import fly from '../assets/images/fly.svg';
import form, { useState } from 'react';
import Price from './Price';


function Content(props) {
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');

    const handleFirstNameChange = (event) => {
        setFirstName(event.target.value);
    }

    const handleLastNameChange = (event) => {
        setLastName(event.target.value);
    }
    return (
        <section className="bg-pegasus-yellow rounded-t-3xl flex items-center">
            <div className="container relative">
                <div className='bg-pegasus-white h-100 w-100 rounded-full'></div>
                <img src={fly} alt="" className="md:w-2/5 sm:w-auto mx-auto mt-36 relative z-10" />
                <div className="content flex items-center flex-col md:flex-row ">
                    <h1 className="text-pegasus-white font-bold text-4xl md:text-6xl p-4 flex-4 md:w-1/4 leading-snug">Pegasus
                        Digiturk iş birliği</h1>
                    <p className="text-pegasus-white p-4 inline-block text-2xl">Digiturk internet paketine başvuran tüm Pegasuslulara
                    gidiş-dönüş uçak bileti değerinde <br />  <strong>7.500 bol bol puan</strong> kazanıyor. Sizde bu fırsatı kaçırmayın.
                    </p>
                </div>
                <div className="flex justify-center">
                    <div className="w-full md:max-w-lg">
                        <form className="pb-8 mb-4 my-18">
                            <div className="grid grid-cols-2 gap-4 px-3 md:px-0">
                                <div>
                                    <label className="block text-grey-darker text-sm font-bold mb-2"
                                        htmlFor="username">
                                        Ad
                                    </label>
                                    <input
                                        className="shadow appearance-none border-bg-gray rounded w-full py-2 px-3 text-grey-darker leading-tight focus:outline-none focus:shadow-outline"
                                        id="username" value={firstName} onChange={handleFirstNameChange} type="text"
                                        placeholder="Ad" />
                                </div>
                                <div>
                                    <label className="block text-grey-darker text-sm font-bold mb-2"
                                        htmlFor="password">
                                        Soyad
                                    </label>
                                    <input
                                        className="shadow appearance-none border-bg-gray rounded w-full py-2 px-3 text-grey-darker leading-tight focus:outline-none focus:shadow-outline"
                                        id="username" value={lastName} onChange={handleLastNameChange} type="text"
                                        placeholder="Soyad" />

                                </div>
                                <div className="mb-4">
                                    <label className="block text-grey-darker text-sm font-bold mb-2" htmlFor="mail">
                                        Bol Bol Mail Adresi
                                    </label>
                                    <input
                                        className="shadow appearance-none border-bg-gray rounded w-full py-2 px-3 text-grey-darker leading-tight focus:outline-none focus:shadow-outline"
                                        id="mail" type="mail" required placeholder="***@***.com" />
                                </div>
                                <div className="mb-6">
                                    <label className="block text-grey-darker text-sm font-bold mb-2"
                                        htmlFor="phone">
                                        Telefon Numarası
                                    </label>
                                    <input
                                        className="shadow appearance-none border-bg-gray rounded w-full py-2 px-3 text-grey-darker leading-tight focus:outline-none focus:shadow-outline"
                                        id="phone" type="tel" placeholder="05**" maxLength="11" />

                                </div>
                            </div>
                            <div className="flex items-center justify-center">
                                <button type="submit"
                                    className="btn bg-pegasus-red text-xl px-5 text-pegasus-white rounded-2xl h-14 w-5/6">KAYIT
                                    OL
                                </button>
                            </div>
                        </form>
                    </div>
                </div>

                <div>
                    <Price/>

                </div>
            </div>
        </section>);
}

export default Content;